"use client";

import { useAuth } from "@/hooks/useAuth";
import { useAppStore } from "@/store/useAppStore";

export default function AuthButton() {
  const { user } = useAuth();
  const { setIsModalOpen, setActiveModal } = useAppStore();

  const showAuthModal = () => {
    setIsModalOpen(true);
    setActiveModal("auth");
  };
  if (user) {
    return null;
  }
  return (
    <button
      onClick={showAuthModal}
      className="bg-[#CCFF00] hover:opacity-85 text-black h-11 px-6 rounded-full text-sm font-medium transition-opacity cursor-pointer"
    >
      Sign In
    </button>
  );
}
